import Close from '@mui/icons-material/Close';
import MuiDrawer from '@mui/material/Drawer';
import { IconButton } from '@src/common/components/IconButton';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { t } from 'i18next';
import type { PropsWithChildren } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  width?: string;
}

export const Drawer = ({
  open,
  onClose,
  width,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <MuiDrawer open={open} anchor="right" hideBackdrop={true}>
      <Stack
        width={width ?? '76vw'}
        padding={theme.spacing['4']}
        style={{ flex: 1 }}
      >
        <Stack
          zIndex={10}
          position="fixed"
          top="18px"
          right="18px"
          width="fit-content"
        >
          <IconButton onClick={onClose} aria-label={t('close')}>
            <Close fontSize="large" />
          </IconButton>
        </Stack>

        {children}
      </Stack>
    </MuiDrawer>
  );
};
